import React from 'react'
import { PropTypes } from 'prop-types'
import { Badge } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'
import { ReactComponent as CalendarIcon } from '@jisr-hr/design-system/dist/assets/icons/Emails/Calendar/Schedule.svg'
import { ReactComponent as ReasonIcon } from '@jisr-hr/design-system/dist/assets/icons/Support/Help/Question/MessageQuestionCheckmark.svg'
import { ReactComponent as ClockIcon } from '@jisr-hr/design-system/dist/assets/icons/Interface/Essential/Alarm/Clock/Time/Timer.svg'
import { ReactComponent as SuitcaseIcon } from '@jisr-hr/design-system/dist/assets/icons/Office/Work/SuitcasePortfolio1.svg'
import { ReactComponent as MoneyIcon } from '@jisr-hr/design-system/dist/assets/icons/Money/Money.svg'
import { ReactComponent as ListIcon } from '@jisr-hr/design-system/dist/assets/icons/School/Learning/ListTaskCheckmark.svg'
import { ReactComponent as DocumentIcon } from '@jisr-hr/design-system/dist/assets/icons/Files/Documents/File/Text.svg'
import { ReactComponent as PlaneIcon } from '@jisr-hr/design-system/dist/assets/icons/Travel/Plane.svg'
import { ReactComponent as MailIcon } from '@jisr-hr/design-system/dist/assets/icons/Emails/Emails/Letter/Mail.svg'
import { ReactComponent as AttachmentIcon } from 'assets/figma-icons/Attachments.svg'

import styles from './style.module.css'

export const BaseBadge = (props) => (
  <Badge
    style={{ margin: 4, textOverflow: 'ellipsis' }}
    bordered
    size="large"
    variant="stroke"
    {...props}
  />
)

export const TypeBadge = ({ type, label, ...rest }) => (
  <BaseBadge
    type={type}
    label={<strong>{label}</strong>}
    {...rest}
  />
)

TypeBadge.propTypes = {
  type: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

TypeBadge.defaultProps = {
  type: 'primary',
}

export const InfoBadge = (props) => (
  <BaseBadge
    type="gray"
    {...props}
  />
)
export const CancellationBadge = (props) => (
  <BaseBadge
    type="accent2"
    label={I18n.t('cancellation')}
    {...props}
  />
)

export const DateBadge = (props) => (
  <InfoBadge
    startIcon={() => <CalendarIcon className={styles.iconStroke} />}
    {...props}
  />
)
export const ReasonBadge = ({ label, ...rest }) => (
  <InfoBadge
    startIcon={() => <ReasonIcon className={styles.iconStroke} />}
    label={typeof label === 'string' && label.length > 22 ? `${label?.substring(0, 20)}...` : label}
    {...rest}
  />
)

ReasonBadge.propTypes = TypeBadge.propTypes

export const TimeBadge = (props) => (
  <InfoBadge
    startIcon={() => <ClockIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const MoneyBadge = (props) => (
  <InfoBadge
    data-private
    startIcon={() => <MoneyIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const ItemBadge = (props) => (
  <InfoBadge
    startIcon={() => <ListIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const TravelBadge = (props) => (
  <InfoBadge
    startIcon={() => <PlaneIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const DocumentBadge = (props) => (
  <InfoBadge
    startIcon={() => <DocumentIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const LetterBadge = (props) => (
  <InfoBadge
    startIcon={() => <MailIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const HiringPositionBadge = (props) => (
  <InfoBadge
    startIcon={() => <SuitcaseIcon className={styles.iconStroke} />}
    {...props}
  />
)

export const AttachmentBadge = (props) => (
  <InfoBadge
    startIcon={() => <AttachmentIcon className={styles.iconStroke} />}
    {...props}
  />
)
